import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {

  }

  /**
   * UTILS DATE FUNCTIONS
   * getDateWithCurrentTime()
   * getDateString()
  */
  getDateWithCurrentTime(date: Date): Date {
    const _ = moment();
    const newDate = moment(date).add({ hours: _.hour(), minutes: _.minute() });
    return newDate.toDate();
  }

  getDateString(date: Date, format?: string): string {
    const fm = format ? format : 'YYYY-MM-DD';
    return moment(date).format(fm);
  }


  getDateAfterDays(dayCount: number, dateString: boolean, format?: string) {
    const date = new Date();
    date.setDate(date.getDate() + dayCount);

    if (dateString) {
      const fm = format ? format : 'YYYY-MM-DD';
      return moment(date).format(fm);
    } else {
      return date.toString();
    }
  }


  /**
   * GET RANDOM NUMBER FUNCTION
   * getRandomInt()
  */
  getRandomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // REGEX SEARCH VARIABLE
  searchWithRegex = (collection: any[], term: string, opts: { caseSensitive: boolean, includedKeys: string[] }) => {
    const filterBy = () => {
      const searchTerms = (!opts.caseSensitive) ? new RegExp(term, 'i') : new RegExp(term)
      return (obj) => {
        for (const key of Object.keys(obj)) {
          if (searchTerms.test(obj[key]) &&
            opts.includedKeys.includes(key)) return true
        }
        return false
      }
    };
    return collection.filter(filterBy());
  }

  getImageName(originalName: string): string {
    const array = originalName.split('.');
    array.pop();
    return array.join('');
  }

  roundNumber(num: number): number{
    const integer = Math.floor(num);
    const fractional = num - integer;

    //Converting the fractional to the integer
    const frac2int = (fractional * 100) / 5;
    const fracCeil = Math.fround(frac2int);

    //transforming inter into fractional
    const FracOut = (fracCeil * 5) / 100;
    const ans = integer + FracOut;

    return Number((Math.round(ans * 100) / 100).toFixed(2));
  }

  roundNumberString(num: number): string{
    const integer = Math.floor(num);
    const fractional = num - integer;

    //Converting the fractional to the integer
    const frac2int = (fractional * 100) / 5;
    const fracCeil = Math.ceil(frac2int);

    //transforming inter into fractional
    const FracOut = (fracCeil * 5) / 100;
    const ans = integer + FracOut;

    return (Math.round(ans * 100) / 100).toFixed(2);
  }

  validateEmail(str: string) {
    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return !!str.match(mailFormat);
  }

  getHostBaseUrl() {
    return new URL(document.location.href).origin;
  }

}
